import {
  Component,
  ElementRef,
  inject,
  input,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  KtdGridComponent,
  KtdGridLayout,
  KtdGridModule,
} from "@katoid/angular-grid-layout";
import { CommonModule } from "@angular/common";
import { Widget } from "../../models/dashboard.model";
import { SharedModule } from "../../../../shared/shared.module";
import { WidgetContainerComponent } from "../../containers/widget-container/widget-container.component";
import { WindowHelperService } from "../../../../shared/services/window-helper.service";
import { DashboardFacadeService } from "../../services/dashboard-facade.service";

@Component({
  selector: "vl-dashboard",
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    KtdGridModule,
    WidgetContainerComponent,
  ],
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit, OnDestroy {
  dashboardFacade = inject(DashboardFacadeService);

  @Input() containerElement: HTMLElement;
  widgets = this.dashboardFacade.displayWidgets;
  edition = this.dashboardFacade.getState().edition;
  column = this.dashboardFacade.dashboardColumn;

  customLoading = input<boolean>(false);
  editable = input<boolean>(true);

  rowHeight = input<number>(150);

  @ViewChild(KtdGridComponent, { static: true }) grid: KtdGridComponent;
  @ViewChild("dashboard", { static: true }) elem: ElementRef;

  sizeObserver;
  dragging = false;

  ngOnInit(): void {
    this.manageRefreshGrid();
  }

  manageRefreshGrid() {
    this.sizeObserver = WindowHelperService.newSizeObserver(() => {
      if (!this.dragging) {
        this.grid.resize();
      }
    });
    this.sizeObserver.observe(this.elem.nativeElement);
  }

  ngOnDestroy(): void {
    this.sizeObserver?.disconnect();
  }

  onLayoutUpdated(layout: KtdGridLayout): void {
    this.dashboardFacade.updateDisplayWidgets(
      layout.map((e) => {
        const { w, h, x, y, id } = e;
        return {
          ...this.widgets().find((w) => w.id === id),
          w,
          h,
          x,
          y,
        };
      }),
    );
  }

  onRemoveWidget(widget: Widget): void {
    this.dashboardFacade.removeWidget(widget);
  }
}
